import { render, staticRenderFns } from "./MegaMenuCard.vue?vue&type=template&id=d2688164&scoped=true&"
import script from "./MegaMenuCard.vue?vue&type=script&lang=ts&"
export * from "./MegaMenuCard.vue?vue&type=script&lang=ts&"
import style0 from "./MegaMenuCard.vue?vue&type=style&index=0&id=d2688164&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2688164",
  null
  
)

export default component.exports